export type ParsedAdCredentialIdentity = {
  username: string;
  domain?: string;
};

export const normalizeAdSamAccountName = (username: string): string => {
  const trimmed = username.trim();
  if (trimmed.length === 0) {
    return trimmed;
  }

  const backslashIndex = trimmed.lastIndexOf('\\');
  if (backslashIndex >= 0) {
    return trimmed.slice(backslashIndex + 1).trim();
  }

  const atIndex = trimmed.indexOf('@');
  if (atIndex > 0) {
    return trimmed.slice(0, atIndex).trim();
  }

  return trimmed;
};

export const parsePastedAdCredentialIdentity = (
  value: string,
): ParsedAdCredentialIdentity => {
  const trimmed = value.trim();
  if (trimmed.length === 0) {
    return { username: '' };
  }

  const backslashIndex = trimmed.lastIndexOf('\\');
  if (backslashIndex >= 0) {
    return {
      domain: trimmed.slice(0, backslashIndex).trim() || undefined,
      username: trimmed.slice(backslashIndex + 1).trim(),
    };
  }

  const atIndex = trimmed.indexOf('@');
  if (atIndex > 0) {
    return {
      username: trimmed.slice(0, atIndex).trim(),
      domain: trimmed.slice(atIndex + 1).trim() || undefined,
    };
  }

  return { username: trimmed };
};

export const formatAdCredentialIdentity = ({
  username,
  domain,
}: {
  username: string;
  domain?: string | null;
}): string => {
  const sam = normalizeAdSamAccountName(username);
  if (domain && domain.length > 0) {
    return `${domain}\\${sam}`;
  }
  return sam;
};

export const resolveAdCredentialDomain = ({
  credentialDomain,
  surfaceDomainName,
}: {
  credentialDomain?: string | null;
  surfaceDomainName?: string;
}): string | undefined => {
  const domain = credentialDomain?.trim();
  if (domain && domain.length > 0) {
    return domain;
  }
  const fallback = surfaceDomainName?.trim();
  return fallback && fallback.length > 0 ? fallback : undefined;
};
